var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9153 0.845255L11.6392 17.392C11.3837 18.066 10.7575 18.2003 10.2485 17.6907C10.2485 17.6907 6.29456 13.7368 5.93427 13.3765C5.57399 13.0162 5.69911 12.3081 6.21267 11.8024L14.9354 3.2146C15.449 2.70889 15.4012 2.65387 14.8286 3.0921L5.00868 10.6148C4.43681 11.053 3.55183 10.9947 3.0422 10.4851L0.3093 7.75217C-0.200334 7.24254 -0.0660475 6.61696 0.608006 6.36083L17.1547 0.0847337C17.8288 -0.170738 18.1707 0.171201 17.9153 0.845255ZM3.77652 12.1456C3.5217 11.8908 3.31339 11.9773 3.31339 12.3376V15.3417C3.31339 15.7019 3.56624 15.8447 3.87478 15.6594L5.44757 14.7154C5.75675 14.5301 5.80064 14.1698 5.54583 13.915L3.77652 12.1456Z",
    fill: "#61676B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.c930fb06d4b69e8e54f51d12d73c573b.svg";
export { ForwardRef as ReactComponent };